import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import _ from "lodash";
import { cn } from "@/core/helpers/cn";
import { ElevatorButton } from "@/domains/estate/components/elevator/components/ElevatorButton";
import { ElevatorEconomyNumber } from "@/domains/estate/components/elevator/components/ElevatorPanelNumber";
import { ElevatorEconomyProps } from "@/domains/estate/components/elevator/components/economy/ElevatorEconomy";
import { ElevatorEconomyFrame } from "@/domains/estate/components/elevator/components/economy/ElevatorEconomyFrame/ElevatorEconomyFrame";

const variant = EstateComplexLevel.Economy;

export function ElevatorEconomySmall({
  currentFloor,
  targetFloor,
  floors,
  onTargetFloorChange,
}: Omit<ElevatorEconomyProps, "size">) {
  return (
    <ElevatorEconomyFrame size="sm">
      <div className="grid grid-cols-2 w-full px-[20px] gap-[26px]">
        {floors.map((floor) => {
          return (
            <div key={floor} className="flex flex-row items-center gap-2">
              {floor % 2 === 0 && <ElevatorEconomyNumber value={floor} />}

              <ElevatorButton
                key={floor}
                variant={variant}
                isActive={floor === targetFloor}
                onClick={() => onTargetFloorChange(floor)}
                className={cn(
                  floor === currentFloor &&
                    "brightness-125 shadow-[0_0_16px_rgba(255,255,255,1.0)]",
                )}
              />

              {floor % 2 !== 0 && <ElevatorEconomyNumber value={floor} />}
            </div>
          );
        })}
      </div>
    </ElevatorEconomyFrame>
  );
}
